import { NgClass } from '@angular/common';
import {
  Component,
  computed,
  effect,
  inject,
  input,
  signal,
} from '@angular/core';
import { ImagePreloadService } from '@shared/services/image-preload.service';
import { PlatformService } from '@shared/services/platform-service.service';

@Component({
  selector: 'app-app-image-multiple-quality',
  standalone: true,
  imports: [NgClass],
  templateUrl: './app-image-multiple-quality.component.html',
  styleUrl: './app-image-multiple-quality.component.scss',
})
export class AppImageMultipleQualityComponent {
  imagePath = input<string>();
  class = input<string>('');
  minWidth = input<number>(200);
  maxWidth = input<number>(900);
  loading = input<'eager' | 'lazy'>('lazy');
  hq = input(false);

  loadedLq = signal(false);
  loaded = signal(false);

  currentWidth = computed(() =>
    this.loaded() ? this.maxWidth() : this.minWidth()
  );
  currentSrc = computed(() =>
    this.imagePath() ? this.imagePath() + '?w=' + this.currentWidth() : null
  );

  showLqImage = signal(false);

  platformService = inject(PlatformService);
  preloadImage = inject(ImagePreloadService);

  constructor() {
    setTimeout(() => {
      this.showLqImage.set(true);
    }, 300);

    if (this.hq()) {
      this.onLoad(false);
    }

    effect(
      () => {
        if (this.hq()) {
          this.onLoad(false);
        }
      },
      {
        allowSignalWrites: true,
      }
    );
  }

  async onLoad(fromEvent = true) {
    await this.platformService.runOnBrowser(async () => {

      if (
        this.currentWidth() === this.minWidth() &&
        this.loaded() === false &&
        this.hq()
      ) {
        await this.preloadImage.preloadImage(
          this.imagePath() + `?w=${this.maxWidth()}`
        );
        this.loaded.set(true);
      }
    });
  }
}
